import request from '../helpers/request';

const bindCallToRequest = async ({ callId, requestId }) => {
  return await request.post(
    '/Phone/bind_call',
    { callId, requestId },
    'Не удалось прикрепить звонок к заявке',
    'Error'
  );
};

export default bindCallToRequest;
